function ClearSessionCredentials() {
  sessionStorage.removeItem('controllers');
  sessionStorage.removeItem('user');
  document.cookie = 'SESSID=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
}

function CleanUp() {
  ClearSessionCredentials();
  localStorage.clear();
}

const Auth = {
  isAuthenticated: false,

  async validateSession(api_url, options = {}) {
    try {
      const response = await fetch(api_url, { cache: 'no-store', ...options });

      if (response.ok) {
        return { authenticated: true, username: await response.text() };
      }

      if (response.status === 401 || response.status === 403) {
        return { authenticated: false };
      }

      return null;
    } catch (_) {
      return null;
    }
  },

  invalidateSession() {
    Auth.isAuthenticated = false;
    ClearSessionCredentials();
  },

  async signin(cb, username, password, otp, api_url) {
    let req = username + '\n' + password;
    if (otp != null) {
      req += '\n' + String(otp);
    }

    if ((process.env.REACT_APP_INDUSTRIAL ?? 'false') === 'true') {
      req = JSON.stringify({ username: username, password: password }); // use this for industrial. When DTOs are fully implemented we can remove this
    }

    let response;
    let text;
    try {
      response = await fetch(api_url, { method: 'POST', body: req });
      text = await response.text();
    } catch (_) {
      cb('Unable to complete login. Check the connection and try again.');
      return;
    }

    if (response.ok) {
      if (text === '_2fa_required') {
        cb('_2fa_required');
      } else {
        Auth.isAuthenticated = true;
        document.cookie = text;
        cb('good');
      }
    } else if (response.status === 401) {
      cb(text === '_2fa_failed' ? '2FA failed' : 'Invalid username or password.');
    } else {
      cb('login failed: ' + response.status);
    }
  },

  signout(cb, api_url) {
    Auth.isAuthenticated = false;
    fetch(api_url, { method: 'POST' }).then((_) => {
      CleanUp();
      cb();
    });
    // TODO (fux): handle errors
  },

  register(cb, username, password, password2, email, api_url) {
    let req = { id: username, pw1: password, pw2: password2 };
    if (email !== '') req['email'] = email;
    req['language'] = localStorage.getItem('i18nextLng') || 'de';
    fetch(api_url, { method: 'POST', body: JSON.stringify(req) })
      .then((response) => {
        if (response.ok) {
          response.text().then((text) => {
            // Older servers overwrite 202 with 200 but keep this failure body.
            // Their session cookie is supplied by the Set-Cookie header.
            const legacyEmailFailure = text === 'Invalid email?';
            Auth.isAuthenticated = true;
            if (!legacyEmailFailure) document.cookie = text;
            cb('good', response.status === 202 || legacyEmailFailure);
          });
        } else {
          response
            .text()
            .then((text) => cb('registration failed: ' + response.status + ' ' + text));
        }
      })
      .catch((error) => cb('registration failed: ' + error + ', http: "' + api_url + '"'));
  },

  deleteAccount(cb, api_url) {
    fetch(api_url, { method: 'POST' })
      .then((response) => {
        if (response.ok) {
          CleanUp();
          sessionStorage.clear();
          cb('good');
        } else {
          cb('delete_account_error');
        }
      })
      .catch((error) => cb('Deleting account failed: ' + error));
  }
};

export default Auth;
